import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation } from '../../hooks/useApi';
import { useSession } from '../../session/SessionContext';
import { Card, Field } from '../../components/ui';
import { InlineError } from '../../components/ErrorView';
import { routes } from '../../api/routes';

/**
 * 2FA challenge. Reached only when `/auth/login` said the second factor is
 * required — the client never decides that on its own.
 */
export function TwoFactorChallenge() {
  const nav = useNavigate();
  const location = useLocation();
  const { refresh } = useSession();
  const state = location.state as { email?: string; password?: string; from?: string } | null;
  const [totp, setTotp] = useState('');
  const login = useMutation<Record<string, unknown>, unknown>(routes.auth.login);

  if (!state?.email) {
    nav('/login', { replace: true });
    return null;
  }

  return (
    <div className="narrow">
      <Card title="Two-factor code">
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const res = await login.run({
              email: state.email,
              password: state.password,
              totp,
            });
            if (res === null) return;
            await refresh();
            nav(state.from ?? '/bots', { replace: true });
          }}
        >
          <Field id="totp" label="Six-digit code" hint="From your authenticator app.">
            <input
              id="totp"
              className="input input-narrow"
              inputMode="numeric"
              autoComplete="one-time-code"
              pattern="\d{6}"
              required
              value={totp}
              onChange={(e) => setTotp(e.target.value)}
            />
          </Field>
          {login.problem ? <InlineError problem={login.problem} /> : null}
          <button type="submit" className="btn btn-primary" disabled={login.pending}>
            {login.pending ? 'Checking…' : 'Continue'}
          </button>
        </form>
      </Card>
    </div>
  );
}
